// extracted by mini-css-extract-plugin
export default {"soft-limit-input-style":"ReportEditForm__soft-limit-input-style___mXhIO","email-address":"ReportEditForm__email-address___Ry7PV"};